export function v2PhotoUrl (photo) {
  if (!photo) return null
  if (photo.type === 'map') return photo.url
  if (photo.type === 'photo') return 'https://bytbostad.se/bilder/card/' + photo.path + '.jpg'
  return null
}
